module.exports = __webpack_public_path__ + "img/orbit-card-pool-claims.f0c909b5.png";